import React from "react";
import cs from "classnames";

// COMPONENTS
import { Icon as PLIcon } from "@lululemon/ecom-pattern-library-icon";
import { linealTagIcon, tagIcon } from "@lululemon/ecom-pattern-library-icons";

import { ThumbnailImage } from "../../shared/components/thumbnails";
import { IMAGE_TYPE, SHOP_THIS_LOOK } from "../utils/constants";

// STYLES
import styles from "../styles/carousel.module.scss";

const CarouselThumbnails = ({
  activeSlide,
  isMobile,
  shouldShowModelIsWearing,
  mediaInfo,
  productImageAlt
}) =>
  mediaInfo?.map((item, index) => {
    const isModelIsWearingSlide =
      shouldShowModelIsWearing && index === mediaInfo?.length - 1;
    const isActive = index === activeSlide;
    const { type, posterImageUrl, url } = item;
    const label = `Slide ${index + 1}`;
    const analyticsValue = `pdp-carousel-img-${index + 1}`;
    const modelIsWearingSlide = () => {
      if (isModelIsWearingSlide) {
        return (
          <PLIcon
            content={linealTagIcon}
            className={cs(styles.thumbnailImage, styles.tagIcon)}
          />
        );
      }
      return (
        <ThumbnailImage
          lazy
          imageSrc={type === IMAGE_TYPE ? url : posterImageUrl}
          imageAlt={`${productImageAlt} button select list item`}
        />
      );
    };

    if (!isMobile) {
      return (
        <div
          className={cs(styles.thumbnails, {
            [styles.thumbnailsActive]: isActive
          })}
          key={url}
          data-lulu-track={`pdp-product-thumbnail-${index}`}
        >
          {modelIsWearingSlide()}
        </div>
      );
    }

    return (
      <span
        key={url}
        role="button"
        aria-label={label}
        data-lulu-track={analyticsValue}
        className={
          isModelIsWearingSlide
            ? styles.modelIsWearingPagination
            : styles.defaultBullet
        }
        data-testid="carousel-thumbnail"
      >
        {isModelIsWearingSlide ? (
          <PLIcon
            className={styles.modelIsWearingPaginationIcon}
            title={SHOP_THIS_LOOK}
            content={tagIcon}
          />
        ) : null}
      </span>
    );
  });

export default CarouselThumbnails;
